import { render } from "./AddFamily.vue?vue&type=template&id=1b9fee9e&scoped=true"
import script from "./AddFamily.vue?vue&type=script&lang=js"
export * from "./AddFamily.vue?vue&type=script&lang=js"

import "./AddFamily.vue?vue&type=style&index=0&id=1b9fee9e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9fee9e"]])

export default __exports__